// extracted by mini-css-extract-plugin
export default {"wrapper":"burger_wrapper__OFgld","container":"burger_container__HKV9u","active":"burger_active__i6NwF"};